import React from "react";
import type { TIconName } from "~/lib/icon-names";
import { NamedIcon } from "./named-icon";

export const OFFER_TAG_PROPERTIES = [
  "Number of sessions",
  "Program duration",
  "Session duration",
  "Delivery method",
  "Session format",
  "Group size",
] as const;

export const OFFER_TAG_ICONS: Record<
  (typeof OFFER_TAG_PROPERTIES)[number],
  TIconName
> = {
  "Number of sessions": "calendar",
  "Program duration": "clock",
  "Session duration": "clock",
  "Delivery method": "globe",
  "Session format": "globe",
  "Group size": "users",
};

// Minimal interface for tag data
export interface MinimalTagData {
  id: string;
  title: string;
  property: string;
  icon?: TIconName; // Optional direct icon override
}

// Props for the OfferTag component
export interface OfferTagProps {
  tag: MinimalTagData;
}

export const OfferTag = ({ tag }: OfferTagProps) => {
  // Use direct icon if provided, otherwise fall back to property-based mapping
  const icon =
    tag.icon ||
    OFFER_TAG_ICONS[tag.property as (typeof OFFER_TAG_PROPERTIES)[number]];

  return (
    <div className="flex flex-col items-center gap-2">
      <div className="flex items-center justify-center gap-2">
        <NamedIcon name={icon} className="text-brand-700" />
        <span className="text-text-primary">{tag.title}</span>
      </div>
      <span className="text-text-tertiary text-xs leading-none">
        {tag.property}
      </span>
    </div>
  );
};
